export default function Privacy() {
  return (
    <div className="max-w-3xl mx-auto px-6 py-16 lg:py-24" data-testid="privacy-page">
      <div className="overline text-[#4A1525] mb-4">Legal</div>
      <h1 className="font-serif text-5xl md:text-7xl tracking-tighter leading-[0.95] mb-4">Privacy policy.</h1>
      <p className="text-[#5C5C5C] mb-16">Last updated: February 2026</p>

      <div className="space-y-10 text-[#1A1A1A] leading-relaxed">
        <section>
          <h2 className="font-serif text-2xl mb-3">Our commitment</h2>
          <p className="text-[#5C5C5C]">Discretion is the foundation of our house. We collect only what we need to serve you, we never sell your data, and we protect it with the same care we take with every seam.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">Information we collect</h2>
          <ul className="list-disc list-inside space-y-2 text-[#5C5C5C]">
            <li><span className="text-[#1A1A1A]">Account information</span> — name, email, and password (hashed) when you create an account.</li>
            <li><span className="text-[#1A1A1A]">Order information</span> — shipping address, items purchased, and payment confirmation from Stripe. We never store your full card number.</li>
            <li><span className="text-[#1A1A1A]">Communication</span> — messages you send us via our contact form or email.</li>
            <li><span className="text-[#1A1A1A]">Usage data</span> — basic analytics (pages visited, device, referrer) to improve the site experience.</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">How we use your information</h2>
          <ul className="list-disc list-inside space-y-2 text-[#5C5C5C]">
            <li>To process and deliver your orders.</li>
            <li>To send order confirmations and shipping updates.</li>
            <li>To respond to your enquiries.</li>
            <li>To improve our products and site experience.</li>
            <li>To send occasional editorial emails (only if you subscribe — you may unsubscribe at any time).</li>
          </ul>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">Who we share it with</h2>
          <p className="text-[#5C5C5C] mb-3">We share the minimum data necessary with trusted partners who help us operate the store:</p>
          <ul className="list-disc list-inside space-y-2 text-[#5C5C5C]">
            <li><span className="text-[#1A1A1A]">Stripe</span> — to process card payments securely.</li>
            <li><span className="text-[#1A1A1A]">Resend</span> — to send transactional email (order confirmations, receipts).</li>
            <li><span className="text-[#1A1A1A]">Shipping partners</span> — to fulfil delivery of your parcel.</li>
          </ul>
          <p className="text-[#5C5C5C] mt-4">We never sell, rent, or trade your personal information.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">Cookies</h2>
          <p className="text-[#5C5C5C]">We use minimal, essential cookies to keep you signed in and remember your bag. We do not use third-party advertising cookies.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">Your rights</h2>
          <p className="text-[#5C5C5C]">You have the right to access, correct, or delete your personal data at any time. Email <a href="mailto:admin@iamravishing.com" className="text-[#4A1525] underline underline-offset-4">admin@iamravishing.com</a> and we will respond within 30 days.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">Data security</h2>
          <p className="text-[#5C5C5C]">All data is encrypted in transit (TLS) and at rest. Passwords are hashed using industry-standard bcrypt. Payment details are handled entirely by Stripe and never touch our servers.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">Children</h2>
          <p className="text-[#5C5C5C]">Iamravishing is intended for customers aged 18 and older. We do not knowingly collect information from minors.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">Changes to this policy</h2>
          <p className="text-[#5C5C5C]">We may update this policy from time to time. The "last updated" date at the top will reflect any changes. Continued use of the site after changes means you accept the revised policy.</p>
        </section>

        <section>
          <h2 className="font-serif text-2xl mb-3">Contact</h2>
          <p className="text-[#5C5C5C]">For any privacy questions, write to <a href="mailto:admin@iamravishing.com" className="text-[#4A1525] underline underline-offset-4">admin@iamravishing.com</a>.</p>
        </section>
      </div>
    </div>
  );
}
